import { coaches } from '@/mocks/roster';
import CoachCard from './CoachCard';

export default function CoachingStaffSection() {
  const headCoach = coaches.find((c) => c.title === 'Head Coach');
  const assistants = coaches.filter((c) => c.title !== 'Head Coach');

  return (
    <section className="w-full py-16 md:py-20 px-6 md:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <p className="text-[#4a1a6b] text-xs font-bold tracking-widest uppercase mb-2" style={{ fontFamily: "'Oswald', sans-serif" }}>
            Leadership
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-[#2a0a3d] uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>
            Coaching Staff
          </h2>
        </div>

        {/* Head Coach Featured */}
        {headCoach && (
          <div className="mb-10">
            <CoachCard coach={headCoach} featured />
          </div>
        )}

        {/* Divider */}
        <div className="flex items-center gap-4 mb-8">
          <div className="flex-1 h-px bg-gray-100"></div>
          <span className="text-xs font-bold tracking-widest uppercase text-gray-400" style={{ fontFamily: "'Oswald', sans-serif" }}>
            Assistant Coaches
          </span>
          <div className="flex-1 h-px bg-gray-100"></div>
        </div>

        {/* Assistant Coaches Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {assistants.map((coach) => (
            <CoachCard key={coach.id} coach={coach} />
          ))}
        </div>
      </div>
    </section>
  );
}
